import React, { useState, useEffect } from 'react';
import MutualLogo from '../../images/mutual-logo.png';
import MutualPioneerLogo from '../../images/pioneer-logo.png';
import MutualLogoWhite from '../../images/mutual-logo-white.png';
import { useCustomContext } from '../ContextHook';

type props = {
    onClick: () => void
}

const logoStyle = { height: '35px', alignSelf: 'center', cursor: 'pointer' }

function getHeaderLogo(logoName: string | undefined): string {
    if (logoName !== undefined) {
        if (logoName === 'pioneer') {
            return MutualPioneerLogo
        }
        else {
            return MutualLogoWhite
        }
    }
    return MutualLogoWhite
}

export const HeaderMutualLogo: React.FC<props> = (props) => {
    const [logoSrc, setLogoSrc] = useState(MutualLogo);
    const { configs } = useCustomContext()
    const currentEvent = configs?.currentEvent;

    useEffect(() => {
        const updateLogoSrc = () => {
            if (window.innerWidth < 600) {
                setLogoSrc(getHeaderLogo(currentEvent?.name));
            } else {
                setLogoSrc(MutualLogo);
            }
        };

        updateLogoSrc();
        window.addEventListener('resize', updateLogoSrc);

        return () => window.removeEventListener('resize', updateLogoSrc);
    }, [currentEvent]);
    return <img src={logoSrc} alt="Header Mutual Logo" style={logoStyle} onClick={() => props.onClick()} />
}
